/* Movatic WMS — Frontend | CesarFilho 932048016 */
import CrudList from '@/components/CrudList'

export default function Sites() {
  return (
    <CrudList
      title="Sites"
      endpoint="/api/core/sites/"
      columns={[
        { key: 'code', header: 'Código' },
        { key: 'name', header: 'Nome' },
        { key: 'company', header: 'Empresa', render: (r:any) => r.company?.code ?? r.company_code ?? '—' },
      ]}
    />
  )
}
